import { render } from "./MultiEditHeader.vue?vue&type=template&id=6beca9f8"
import script from "./MultiEditHeader.vue?vue&type=script&lang=js"
export * from "./MultiEditHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__